import { getPaddingString, toRGBA } from "../parser/utils";
import QRCode from 'qrcode';

export default ({ data, id }) => {
  const { width, align, height, color, contentID, content, type } = data;

  let couponContent = "";

  if (type === "qrcode" && content) {
    try {
      // 使用 QRCode.toString() 同步生成 SVG 格式的二维码
      QRCode.toString(content, { type: 'svg' }, (err, svg) => {
        if (err) {
          console.error('Failed to generate QR Code:', err);
          // 如果生成失败，使用占位符图片
          couponContent = `<img src="https://via.placeholder.com/150" alt="QR Code" style="width: ${width}px; height: ${height}px;" />`;
        } else {
          // 修改 SVG 宽度和高度
          const modifiedSvg = svg.replace('<svg', `<svg width="${width}px" height="${height}px"`);
          couponContent = `<div style="width: ${width}px; height: ${height}px;">${modifiedSvg}</div>`;
        }
      });
    } catch (err) {
      console.error('Error:', err);
      // 如果捕获到错误，显示占位符
      couponContent = `<img src="https://via.placeholder.com/150" alt="QR Code" style="width: ${width}px; height: ${height}px;" />`;
    }
  } else if (type === "string") {
    // 如果类型为 string，则直接显示内容
    couponContent = `<div id="${contentID || id}" style="${getPaddingString(data)}; color: ${toRGBA(color)}">
      ${content}
    </div>`;
  }

  return `
    <div id="${contentID || id}" style="${getPaddingString(data)}; display: flex; justify-content: ${align};">
      ${couponContent}
    </div>
  `;
};
